module.exports = __webpack_public_path__ + "img/guide.19226611.png";